import React from 'react';
import { Target, Eye, Heart, Award, Users, Coffee } from 'lucide-react';
import './About.css';

const team = [
  { name: 'Arjun Mehta', role: 'Chief Executive Officer', img: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&q=80' },
  { name: 'Priya Sharma', role: 'Chief Technology Officer', img: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&q=80' },
  { name: 'Rahul Gupta', role: 'Head of Engineering', img: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&q=80' },
  { name: 'Sneha Patel', role: 'Lead UX Designer', img: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&q=80' },
];

const values = [
  { icon: <Target size={22} />, title: 'Precision', desc: 'We approach every project with surgical focus, ensuring every line of code and decision serves a purpose.' },
  { icon: <Eye size={22} />, title: 'Transparency', desc: 'Clear communication, honest timelines, and complete visibility into your project at every stage.' },
  { icon: <Heart size={22} />, title: 'Partnership', desc: 'We invest in your success as deeply as you do. Your growth is our benchmark for achievement.' },
  { icon: <Award size={22} />, title: 'Excellence', desc: 'We refuse mediocrity. Every deliverable is held to the highest standard of quality and craft.' },
];

export default function About() {
  return (
    <div className="about-page">
      <section className="page-hero">
        <div className="container">
          <span className="section-label">Our Story</span>
          <h1>We Are <span>Tradifyme</span></h1>
          <p>A team of passionate engineers, strategists, and innovators — united by the mission to build technology that drives real-world impact.</p>
        </div>
      </section>

      {/* Mission Vision */}
      <section className="section">
        <div className="container">
          <div className="mv-grid">
            <div className="mv-card">
              <div className="mv-icon"><Target size={24} /></div>
              <h3>Our Mission</h3>
              <p>To empower organizations of all sizes with transformative technology solutions — enabling them to operate smarter, scale faster, and compete with confidence in a digital-first world.</p>
            </div>
            <div className="mv-card">
              <div className="mv-icon"><Eye size={24} /></div>
              <h3>Our Vision</h3>
              <p>To be the most trusted technology partner for enterprises across India and globally — recognized for our engineering excellence, strategic insight, and unwavering commitment to client success.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="section story-section">
        <div className="container story-inner">
          <div className="story-img">
            <img src="https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80" alt="Our office" />
          </div>
          <div className="story-text">
            <span className="section-label">Our Journey</span>
            <h2 className="section-title">From <span>Startup</span> to Enterprise Partner</h2>
            <div className="gold-line" />
            <p className="section-desc" style={{ marginBottom: '1.25rem' }}>
              Founded in Pune, Maharashtra, Tradifyme began as a boutique software consultancy serving local businesses. Over 12 years, we've grown into a full-service technology firm trusted by enterprises across India and beyond.
            </p>
            <p className="section-desc">
              Our growth reflects our philosophy: build relationships as carefully as you build software. Every client partnership has deepened our expertise and expanded our capabilities.
            </p>
            <div className="story-facts">
              <div className="story-fact">
                <Coffee size={16} />
                <span>Founded in Pune, 2012</span>
              </div>
              <div className="story-fact">
                <Users size={16} />
                <span>50+ professionals across India</span>
              </div>
              <div className="story-fact">
                <Award size={16} />
                <span>ISO 27001 certified operations</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="section values-section">
        <div className="container">
          <div className="section-header">
            <span className="section-label">Core Values</span>
            <h2 className="section-title">What <span>Drives Us</span></h2>
          </div>
          <div className="values-grid">
            {values.map((v, i) => (
              <div className="value-card card" key={i}>
                <div className="value-icon">{v.icon}</div>
                <h3>{v.title}</h3>
                <p>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="section team-section">
        <div className="container">
          <div className="section-header center">
            <span className="section-label">The People</span>
            <h2 className="section-title">Meet Our <span>Leadership</span></h2>
            <p className="section-desc" style={{ margin: '0 auto' }}>Experienced professionals who bring decades of combined expertise across technology, business, and strategy.</p>
          </div>
          <div className="team-grid">
            {team.map((member, i) => (
              <div className="team-card" key={i}>
                <div className="team-img-wrap">
                  <img src={member.img} alt={member.name} />
                </div>
                <div className="team-info">
                  <h4>{member.name}</h4>
                  <span>{member.role}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
